<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月10日 16:01:48 +0800
 * @最后修改时间: 2021-12-16 16:07:07
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Leave\LeaveTransactionPropertyGroup\newLeaveTransactionPropertyGroup.vue
 -->
<template>
  <ContentLayout
    :title="$t('label_essweb_leaveTransactionPropertyGroup_form_newTitle')"
    widthClass="max-1000"
    pad="0"
    :initData="leaveTransactionGroupData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'leave_transaction_type_property_group_name',
      'leave_transaction_type_property_group_description',
      'leave_transaction_type_property_group_code',
      'remarks',
    ]"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Stepper :curStep="curStep" :items="stepper">
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  :bindData="
                    leaveTransactionGroupData.leave_transaction_type_property_group_name
                  "
                  maxlength="100"
                  @change="
                    (valueArr) => {
                      leaveTransactionGroupData.leave_transaction_type_property_group_name =
                        valueArr;
                    }
                  "
                  :label="
                    $t(
                      'label_essweb_leaveTransactionPropertyGroup_form_groupNameLabel'
                    )
                  "
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  maxlength="500"
                  :bindData="
                    leaveTransactionGroupData.leave_transaction_type_property_group_description
                  "
                  @change="
                    (valueArr) => {
                      leaveTransactionGroupData.leave_transaction_type_property_group_description =
                        valueArr;
                    }
                  "
                  :label="
                    $t(
                      'label_essweb_leaveTransactionPropertyGroup_form_descriptionLabel'
                    )
                  "
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <normalInputTextFiled
                  maxlength="100"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  :label="
                    $t(
                      'label_essweb_leaveTransactionPropertyGroup_form_codeLabel'
                    )
                  "
                  v-model="
                    leaveTransactionGroupData.leave_transaction_type_property_group_code
                  "
                />
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                <v-sheet class="text--secondary">{{
                  $t(
                    "label_essweb_leaveTransactionPropertyGroup_form_remarkLabel"
                  )
                }}</v-sheet>
                <v-textarea
                  rows="5"
                  no-resize
                  maxlength="500"
                  dense
                  counter="500"
                  filled
                  single-line
                  v-model="leaveTransactionGroupData.remarks"
                  name="input-7-4"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-2>
          <PropertyList
            :items="desserts"
            @edit="toEditProperty"
            :listdata="PropertyListData"
          />
        </template>
      </Stepper>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        :newBtn="stepper.length == curStep && curStep != 0 ? true : false"
        :step="stepper.length == curStep ? false : true"
        @next="toNext"
        :preStep="curStep > 1 ? true : false"
        @pre="curStep = curStep - 1"
        @new="toNew"
        @cancel="$toBack(isChanged)"
      />
    </template>
    <!-- actions -->
    <!-- tools -->
    <template v-slot:tools-main>
      <MappingPopup3
        :show="showMappingPopup"
        :PropertyData="PropertyData"
        @close="
          showMappingPopup = false;
          PropertyData = null;
        "
        @confirm="onEditProperty"
      />
    </template>
  </ContentLayout>
</template>
<script>
import MappingPopup3 from "@/Page/EssAdmin/Leave/LeaveTransactionPropertyGroup/components/MappingPopup3.vue";
import { mapGetters } from "vuex";
export default {
  name: "newLeaveTransactionGroup",
  components: { MappingPopup3 },
  computed: {
    ...mapGetters(["companyLang", "staticZone"]),
  },
  data() {
    return {
      curStep: 1,
      isChanged: false,
      changeListArr: [], //修改的数组
      stepper: [
        "label_essweb_leaveTransactionPropertyGroup_form_step_generalLabel",
        "label_essweb_leaveTransactionPropertyGroup_form_step_propertyGroupLabel",
      ],
      showMappingPopup: false,
      PropertyData: null,
      PropertyListData: null,
      selected: [],
      showPGDelete: false,
      page: 1,
      showSelect: false,
      leaveTransactionGroupData: {
        leave_transaction_type_property_group_name: "",
        leave_transaction_type_property_group_description: "",
        leave_transaction_type_property_group_code: "",
        remarks: "",
      },
      desserts: [],
    };
  },
  mounted() {
    // this.leaveTransactionGroupData.leave_transaction_type_property_group_name = this.$getCommonLangKey(
    //   this.companyLang
    // );
    // this.leaveTransactionGroupData.leave_transaction_type_property_group_description = this.$getCommonLangKey(
    //   this.companyLang
    // );
    this.getPropertyList();
  },
  methods: {
    toNext: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.curStep = this.curStep + 1;
    },
    toEditProperty: function (obj) {
      this.PropertyData = obj;
      this.showMappingPopup = true;
    },
    getPropertyList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_transaction_type_property",
        url: "/leave-transaction-type-property/get-list/",
        data: {
          leave_transaction_type_property_group_uuid: "",
        },
      }).then((res) => {
        res.data.forEach((item) => {
          item["changeList"] = [];
          item["property_master_code"] =
            item.leave_transaction_type_property_master_code;
          if (item.property_master_code.indexOf("|") != -1) {
            item["p_property_master_code"] =
              item.property_master_code.substring(
                0,
                item.property_master_code.lastIndexOf("|")
              );
          }
        });
        that.PropertyListData = res.data;
        that.desserts = that.$translateDataToTree(
          res.data,
          "property_master_code",
          "p_property_master_code"
        );
      });
    },
    onEditProperty: function (obj, changeList) {
      // this.findTreeItem(this.desserts, obj.property_master_code, changeList);
      let index = this.PropertyListData.findIndex(
        (ele) => ele.property_master_code == obj.property_master_code
      );
      this.PropertyListData.splice(index, 1, obj);
      // this.showMappingPopup = false;
    },
    findTreeItem: function (tree, code, obj) {
      const that = this;
      tree.some((item) => {
        if (item["property_master_code"] === code) {
          item["changeList"] = obj;
          if (item["changeList"].length == 0) {
            item["value"] = "";
          }
          return true;
        } else {
          if (item.children) {
            that.findTreeItem(item.children, code, obj);
          } else {
          }
        }
      });
    },
    findTreeChange: function (tree) {
      const that = this;
      tree.map((item) => {
        if (item["changeList"])
          if (item["changeList"].length) {
            that.changeListArr.push(
              item["changeList"].filter(
                (ele) => ele.effective_utc_datetime !== "" && ele.value !== ""
              )
            );
          }
        if (item.children) {
          that.findTreeChange(item.children);
        }
      });
      that.changeListArr = Array.prototype.concat.apply([], that.changeListArr); // 数组降维
      that.changeListArr.every((it) => {
        if (it["actionid"]) delete it["actionid"];
      });
      return that.changeListArr;
    },
    toNew: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      const that = this;
      this.changeListArr = [];
      let arrlist = this.findTreeChange(this.desserts);
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_transaction_property_group",
        url: "/leave-transaction-type-property-group/add/",
        data: {
          leave_transaction_type_property_group_code:
            this.leaveTransactionGroupData
              .leave_transaction_type_property_group_code,
          leave_transaction_type_property_group_name: this.$transCommonLangKey(
            this.leaveTransactionGroupData
              .leave_transaction_type_property_group_name
          ),
          leave_transaction_type_property_group_description:
            this.$transCommonLangKey(
              this.leaveTransactionGroupData
                .leave_transaction_type_property_group_description
            ),
          ess_lv_leave_transaction_type_property: arrlist,
          remarks: this.leaveTransactionGroupData.remarks,
        },
      }).then((res) => {
        that.$toBack();
      });
    },
  },
};
</script>
